import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-20 px-4 bg-cream-beige border-y border-gold-light" data-id="element-212" data-mp="3sqtrb7403vqz">
      <div className="max-w-6xl mx-auto" data-id="element-213" data-mp="3nzlhwb2o8adt">
        <div className="text-center mb-12" data-id="element-214" data-mp="3nyk4hzy6nbsx">
          <h2 className="flex items-center justify-center gap-3 text-2xl md:text-4xl font-serif font-bold text-navy" data-id="element-215" data-mp="3nxqumq3xg66k">
            <Star size={28} className="text-gold shrink-0" fill="currentColor" aria-hidden="true" data-id="element-216" data-mp="mrj0jc1ggay" />
            WHAT TAEKWONDO INSTRUCTORS ARE SAYING
          </h2>
          <p className="text-lg text-ink-soft max-w-2xl mx-auto mt-4" data-id="element-217" data-mp="fj0dz8owc7hk">
            Real feedback from instructors using Taekwondo Instructor Ready to save planning time,
            structure classes and improve student progression.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8" data-id="element-218" data-mp="2cctqzv18u437">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-gold-light rounded-2xl p-8 shadow-[0_8px_24px_rgba(16,42,76,0.06)] flex flex-col h-full" data-id="element-219" data-mp="ceabhdzlwe9k" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-5" aria-label="5 out of 5 stars" data-id="element-220" data-mp="102a0a8dcxuli">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={18} fill="currentColor" aria-hidden="true" data-id="element-221" data-mp="1456nydhr8gwb" data-mpi={starIndex} />)}
              </div>

              <blockquote className="text-ink italic text-base leading-relaxed flex-grow" data-id="element-222" data-mp="190vr0qszgfxd">
                “{testimonial.text}”
              </blockquote>

              <div className="border-t border-gold-light mt-6 pt-6 flex items-center gap-4" data-id="element-223" data-mp="3ave8xwqb1z8s">
                <div className="w-12 h-12 rounded-full bg-navy text-gold font-bold flex items-center justify-center shrink-0 border-2 border-gold-light" aria-hidden="true" data-id="element-224" data-mp="hz30lm26s4b6">
                  {testimonial.initials}
                </div>
                <div data-id="element-225" data-mp="m0y9pcqczlzi">
                  <p className="font-bold text-navy" data-id="element-226" data-mp="m0oixmxhpasr">{testimonial.name}</p>
                  <p className="text-sm text-navy-medium" data-id="element-227" data-mp="10y730bz82ztv">{testimonial.role}</p>
                  <p className="text-xs text-ink-soft flex items-center gap-1 mt-0.5" data-id="element-228" data-mp="vznhgcojjq21">
                    <MapPin size={12} aria-hidden="true" data-id="element-229" data-mp="vxt5hnv8z8a3" />
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}